export default "__VITE_ASSET__CudLt08U__"